import { render, staticRenderFns } from "./MajorDes.vue?vue&type=template&id=21a9f260"
import script from "./MajorDes.vue?vue&type=script&lang=js"
export * from "./MajorDes.vue?vue&type=script&lang=js"
import style0 from "./MajorDes.vue?vue&type=style&index=0&id=21a9f260&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ListSchool: require('/app/nuxt/components/ListSchool.vue').default})
